module.exports = "<i class=\"rw-icon\"\r\n   aria-hidden=\"true\"\r\n   ng-class=\"[\r\n      $ctrl.iconType, \r\n      $ctrl.iconSize,\r\n      $ctrl.iconEffect,\r\n      {\r\n         'rw-icon--start': $ctrl.iconStart === true,\r\n         'rw-icon--end': $ctrl.iconEnd === true\r\n      }\r\n   ]\">\r\n</i>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-icon/rw-icon.html
// module id = 1982
// module chunks = 0